import { MultiLangModel } from './Language.model';

export class EditorialModel {
  constructor(data = {}) {
    Object.assign(this, data);
  }

  id?: string;
  name?: MultiLangModel;
  link?: string;
  listOrder?: number;
  imageIcon?: string;
  labelColor!: string;
  categoriesIds?: string[];
  FilterColor?: object;
}
